/*
  Copyright 2019 Bit Factory, Inc.
  This Source Code Form is subject to the terms of the Mozilla Public
  License, v. 2.0. If a copy of the MPL was not distributed with this
  file, You can obtain one at http://mozilla.org/MPL/2.0/.
*/
import platform from 'platform';
export class DeepLink {
    constructor(config) {
        this.config = config;
    }
    link(data) {
        const { domain, link, apn, isi, ibi } = this.config;
        const query = encodeURIComponent(`?uid=${data.uid}&dappName=${data.dappName}`);
        const url = `https://${domain}/`
            + `?link=https://${link}/link/${query}`
            + `&apn=${apn}`
            + `&isi=${isi}`
            + `&ibi=${ibi}`;
        this.setLocation(url);
    }
    sign(docId) {
        const { domain, link, apn, isi, ibi } = this.config;
        const query = encodeURIComponent(`?docId=${docId}`);
        const url = `https://${domain}/`
            + `?link=https://${link}/sign/${query}`
            + `&apn=${apn}`
            + `&isi=${isi}`
            + `&ibi=${ibi}`;
        this.setLocation(url);
    }
    setLocation(location) {
        if (platform.os.family.includes('iOS')) {
            window.open(location, 'qurage-link');
        }
        else {
            window.location.href = location;
        }
    }
}
